import { reverse } from 'named-urls';
import { routing } from '@utils/routing';
import { removeFiltersParams } from '../../../modules/AnalyticsFilters/utils/removeFiltersParams';
export const createGetReportTo = (location) => (reportType, additionalParams) => {
    const searchParams = new URLSearchParams(location.search);
    const cleanedParams = removeFiltersParams(searchParams);
    if (additionalParams) {
        Object.entries(additionalParams).forEach(([key, value]) => {
            if (value !== undefined) {
                if (Array.isArray(value)) {
                    cleanedParams.set(key, value.join(','));
                }
                else {
                    cleanedParams.set(key, value);
                }
            }
        });
    }
    return {
        pathname: reverse(routing.analytics.overview.report.self, { reportType }),
        search: cleanedParams.toString(),
    };
};
